var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    _c(
      "div",
      { staticClass: "createNewComp" },
      [
        _c(
          "b-form",
          { on: { submit: _vm.addOrUpdateOrganizationRecord } },
          [
            _c(
              "div",
              { staticClass: "header" },
              [
                _vm._.get(this.organization, "id", false)
                  ? _c("h4", { staticClass: "card-title mb-0" }, [
                      _vm._v(_vm._s(this.organization.id))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !this.organization.id
                  ? _c("h4", { staticClass: "card-title mb-0" }, [
                      _vm._v("Create New Organization")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-link",
                  {
                    staticClass: "close",
                    attrs: { to: "/admin/organizations/" }
                  },
                  [_c("h4", [_vm._v("X")])]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-card",
              { staticClass: "noBoxShadow" },
              [
                _c("OrganizationForm", {
                  attrs: { isNew: true, organization: _vm.organization }
                }),
                _vm._v(" "),
                _c(
                  "b-alert",
                  {
                    attrs: {
                      fade: "",
                      show: _vm.createOrganizationFailure,
                      variant: "danger"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.createOrganizationFailure)
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { attrs: { "align-h": "end" } },
                  [
                    _c(
                      "b-col",
                      { staticClass: "p-3", attrs: { cols: "auto" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "marginR-32",
                            attrs: {
                              variant: "secondary",
                              href: "/admin/organizations"
                            }
                          },
                          [_vm._v("Cancel")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: { click: _vm.addOrUpdateOrganizationRecord }
                          },
                          [_vm._v("Submit")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "h2",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.createOrganizationPending,
                expression: "createOrganizationPending"
              }
            ],
            staticClass: "u-padding-bottom-20"
          },
          [_vm._v("Updating, please wait ...")]
        ),
        _vm._v(" "),
        _c("pulse-loader", {
          attrs: {
            loading: _vm.createOrganizationPending,
            color: "#0F347B",
            size: "50px"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-188fef88", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188fef88","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/AddOrganization.vue
// module id = 1897
// module chunks = 0